import Chip from "@mui/material/Chip";
import type { ChipProps } from "@mui/material/Chip";

const statusChipConfig: Record<
  string,
  { label: string; color: ChipProps["color"] }
> = {
  PENDING: { label: "Ожидает оплаты", color: "warning" },
  SUCCEEDED: { label: "Оплачен", color: "success" },
  CANCELED: { label: "Отменён", color: "default" },
  REFUNDED: { label: "Возвращён", color: "info" },
};

/**
 * Чип статуса платежа: один и тот же в реестре и на экране деталей,
 * поэтому живёт в domains, нижнем слое фичи.
 */
export function renderPaymentStatus(status: string) {
  const { label, color } = statusChipConfig[status] ?? {
    label: status,
    color: "default" as const,
  };
  return <Chip label={label} color={color} size="small" />;
}
